import React from 'react';
import { MxButton } from '@guildeducationinc/playground-mx';
import { Accordion, TextLink, Typography } from '@guildeducationinc/recess';
import { AcademicPartnerHit } from 'src/queries/user';
import { trackEvent } from 'src/services/analytics';
import { SPONSORSHIP_URL } from 'src/utilities/envConfig';
import styles from './AffiliateCard.module.scss';

interface Props {
	hit: AcademicPartnerHit;
}

export const AffiliateCard: React.FC<Props> = ({ hit }) => {
	const { name, logoUrl, location, locationType, overview, link, objectID, logoAltText } = hit;

	const locationString = () => {
		let formattedLocationString = location;
		switch (locationType) {
			case 'multiple_locations':
				formattedLocationString = 'Multiple locations';
				break;
			case 'multiple_locations_main_location':
				formattedLocationString = `Multiple locations | Main location: ${location}`;
				break;
			case 'online_only':
				formattedLocationString = 'Online only';
				break;
			default:
				break;
		}
		return formattedLocationString;
	};

	const handleClick = () => {
		const eventData = {
			institutionID: objectID,
			offeringLocation: 'gallery',
			product: 'affiliates',
			typedTerm: '',
		};
		trackEvent('InstitutionCardExpanded', eventData);
	};

	const AccordionTitle = ({ isOpen }) => {
		if (isOpen) {
			handleClick();
		}
		return (
			<div className={styles.accordionTitle}>
				<img alt={logoAltText || `${name} logo`} className={styles.schoolLogo} src={logoUrl} />
				<span className={styles.schoolDetails}>
					<Typography variant='title3'>{name}</Typography>
					<Typography variant='body1'>{locationString()}</Typography>
				</span>
			</div>
		);
	};

	return (
		<Accordion title={AccordionTitle}>
			<div className={styles.accordionContent}>
				<div className={styles.schoolOverview}>
					{overview ? (
						<Typography variant='body1'>{overview}</Typography>
					) : (
						<Typography variant='body1'>
							Oops! There was an issue with this school&apos;s information. Don&apos;t worry, you
							can still learn about them by visiting their website.
						</Typography>
					)}
					<TextLink href={link} target='_blank'>
						View school website
					</TextLink>
				</div>
				<div className={styles.button}>
					<MxButton
						appearance='outline'
						href={SPONSORSHIP_URL}
						onClick={() => {
							const eventData = {
								location: 'AffiliateCatalog',
								institutionID: objectID,
								product: 'catalog',
								tag: 'Apply for Sponsorship',
								text: 'Apply',
								type: 'button',
							};
							trackEvent('Clickable', eventData);
						}}
					>
						Apply for Sponsorship Letter
					</MxButton>
				</div>
			</div>
		</Accordion>
	);
};
